import React from 'react';
import logoImage from './assets/logo.svg';
import styles from './styles.scss';

function Footer () {
  return (
    <div className={styles.footer}>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <img src={logoImage} alt="designcue logo" className={styles.footerImage} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>
                Founded by Preston Attebery / Made with Soul in Atlanta / Switchyards: 151 Ted Turner Dr. NW, Atlanta, Ga. 30303
              </p>
              <p>
                pa@designcue.co
              </p>
              <div className={styles.footerSocial}>
                <span>social: </span>
                <a href="https://twitter.com/prestonattebery">TWITTER</a>
                <a href="https://dribbble.com/designcue">DRIBBBLE</a>
                <a href="https://www.instagram.com/prestonattebery/">INSTAGRAM</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js